(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ck-product-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ck-product-guide')) {
    customElements.define('ck-product-guide',class extends HTMLElement {
      connectedCallback() {
        if(this.dataset.ready)return;
        this.panels=Array.from(this.querySelectorAll('.ck-guide__panel'));
        this.panels.forEach(panel=>{panel.id=this.id+'-'+panel.dataset.key;});
        const chart=JSON.parse(this.querySelector('[data-size-chart]').textContent);const chartHost=this.querySelector('[data-structured-chart]');if(chart.sizes?.length&&chart.rows?.length){const wrap=document.createElement('div');wrap.className='ck-guide__scroll';wrap.tabIndex=0;wrap.setAttribute('role','region');wrap.setAttribute('aria-label',this.panels[1].querySelector('summary').textContent);const table=document.createElement('table'),head=document.createElement('thead'),row=document.createElement('tr');const title=document.createElement('th');title.scope='col';title.textContent=this.panels[1].querySelector('summary').textContent;row.append(title);chart.sizes.forEach(size=>{const th=document.createElement('th');th.scope='col';th.textContent=size;row.append(th);});head.append(row);table.append(head);const body=document.createElement('tbody');chart.rows.forEach(r=>{const row=document.createElement('tr'),label=document.createElement('th');label.scope='row';label.textContent=String(r.label).replace(/(?:1\s*\/\s*2|½)\s*chest/ig,'Half chest').replace(/chest\s+to\s+fit/ig,'Chest to fit');row.append(label);chart.sizes.forEach((_,i)=>{const cell=document.createElement('td');cell.textContent=r.values?.[i]||'—';row.append(cell);});body.append(row);});table.append(body);wrap.append(table);chartHost.append(wrap);}
        const target=this.querySelector('[data-size-tables]');
        this.querySelectorAll('[data-description] table').forEach(table=>{
          const title=table.querySelector('tr')?.cells[0]?.textContent.trim();
          if(title){const heading=document.createElement('h3');heading.textContent=title;target.append(heading);}
          const wrap=document.createElement('div');wrap.className='ck-guide__scroll';wrap.tabIndex=0;wrap.setAttribute('role','region');wrap.setAttribute('aria-label',this.panels[1].querySelector('summary').textContent);wrap.append(table);target.append(wrap);
        });
        const labels=(chart.rows||[]).map(r=>String(r.label));
        const body=labels.some(label=>/chest\s+to\s+fit/i.test(label));
        const half=labels.some(label=>/(?:1\s*\/\s*2|½|half)\s*chest/i.test(label));
        this.querySelector('[data-body-note]').hidden=!body;
        this.querySelector('[data-half-note]').hidden=!half;
        this.querySelector('[data-units-note]').hidden=!labels.length;
        this.querySelectorAll('[data-description] h2').forEach(h=>{if(h.textContent.trim()==='Garment specifications and size guides')h.remove();});
        this.dataset.ready='true';
      }
      select(index){const panel=this.panels[index];if(panel){panel.open=true;panel.querySelector('summary').focus();}}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
